module.exports = BMAP_NAVIGATION_CONTROL_ZOOM;